import { Injectable } from '@angular/core';

import { AuthInterceptor } from '@pe/auth';
import { ACCESS_TOKEN_NAME, REFRESH_TOKEN_NAME } from '@pe/checkout/store';

@Injectable()
export class CeAuthInterceptor extends AuthInterceptor {
  // eslint-disable-next-line
  // @ts-ignore
  protected override get token() {
    return localStorage.getItem(ACCESS_TOKEN_NAME);
  }

  // eslint-disable-next-line
  // @ts-ignore
  protected override get refreshToken() {
    return localStorage.getItem(REFRESH_TOKEN_NAME);
  }
}
